import { useStaticQuery, graphql } from 'gatsby';

type UseMagazineProps = {
  magazineId?: string;
  categories?: string[];
};

export const useMagazines = ({ magazineId, categories }: UseMagazineProps) => {
  const allMagazineNodes = useStaticQuery<Queries.GetAllMagazinesQuery>(graphql`
    query GetAllMagazines {
      allMagazines {
        nodes {
          ...MagazineData
        }
      }
    }
  `);
  const allMagazines = [...allMagazineNodes.allMagazines.nodes];
  const filteredMagazines = magazineId
    ? allMagazines.filter((magazine) => magazine.itemId === magazineId)
    : categories
    ? allMagazines.filter((magazine) => magazine.categories?.some((categoryId) => categories.includes(categoryId ?? '')))
    : allMagazines;
  return filteredMagazines;
};

